import React, { useState, useEffect } from "react";
import "./Gallery.css";

const galleryImages = [
  { src: "/images/gallery/community1.jpg", title: "Dahi Handi Celebration" },
  { src: "/images/gallery/ketkeshvar6.jpg", title: "Ketkeshwar Yatra" },
  { src: "/images/gallery/suvarnayug.jpg", title: "Suvarnayug Ganpati Mandir" },
  { src: "/images/gallery/sports2.jpg", title: "Kusti" },
  { src: "/images/gallery/betel-leaf-market.jpg", title: "Paan Bazaar" },
  { src: "/images/gallery/image1.jpg", title: "Ketkeshwar Mandir" },
];

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openModal = (index) => {
    setCurrentIndex(index);
  };

  const closeModal = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  };

  /* KEYBOARD SUPPORT */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentIndex === null) return;

      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [currentIndex]);

  /* MOBILE SWIPE SUPPORT */
  let startX = 0;

  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;

    if (endX - startX > 50) {
      prevImage();
    } else if (startX - endX > 50) {
      nextImage();
    }
  };

  return (
    <div className="gallery">
    <section className="gallery-page">
      <h1 className="gallery-title">Photo Gallery</h1>
      <p className="gallery-subtitle">
        Moments captured from various initiatives and events of Nimgaon Ketki Gram Panchayat.
      </p>

      {/* GRID */}
      <div className="gallery-grid">
        {galleryImages.map((img, index) => (
          <div
            className="gallery-item"
            key={index}
            onClick={() => openModal(index)}
          >
            <img src={img.src} alt={img.title} />
            <div className="gallery-caption">{img.title}</div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {currentIndex !== null && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <span className="modal-close" onClick={closeModal}>✕</span>

            {/* IMAGE */}
            <img
              src={galleryImages[currentIndex].src}
              alt={galleryImages[currentIndex].title}
            />

            <p className="modal-title">
              {galleryImages[currentIndex].title}
            </p>

            {/* NAV BUTTONS */}
            <button className="nav-btn left" onClick={prevImage}>❮</button>
            <button className="nav-btn right" onClick={nextImage}>❯</button>
          </div>
        </div>
      )}
    </section>
    </div>
  );
};

export default Gallery;
